import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';

import MessageComposer from './MessageComposer';
import MessageFeed from './MessageFeed';

const defaultMessageTypeFilter = {
  ANNOUNCEMENTS: true,
  COMMENTS: true,
};

const JobMessages = (props) => {
  const [messageTypeFilter, setMessageTypeFilter] = React.useState(defaultMessageTypeFilter);
  const [sortDir, setSortDir] = React.useState('DESC');

  return (
    <Stack>
      <MessageComposer
        messageTypeFilter={messageTypeFilter}
        setMessageTypeFilter={setMessageTypeFilter}
        sortDir={sortDir}
        setSortDir={setSortDir}
        {...props}
      />
      <MessageFeed
        messageTypeFilter={messageTypeFilter}
        sortDir={sortDir}
        {...props}
      />
    </Stack>
  );
};

JobMessages.propTypes = {
  jobRn: PropTypes.string.isRequired,
  jobMessages: PropTypes.object.isRequired,
  jobMessagesLoading: PropTypes.bool.isRequired,
  jobBackend: PropTypes.object.isRequired,
};

export default React.memo(JobMessages);
